import { Grid, Transition } from 'semantic-ui-react'
import { MarkupText } from 'preact-i18n'
import { SignupLink } from '../atoms/SignupLink'

import MainMenu from './MainMenu'
import FullscreenInfo from './FullScreenInfo'
import Tutorial from './Tutorial'
import { Show } from '../directives'
import { useStore, useTracker } from '../../store'
import { ExpandableBarcodeList } from '../molecules/ExpandableBarcodeList/ExpandableBarcodeList'
import { signal } from '@preact/signals'
import { FrameSourceState } from '@scandit/web-datacapture-core'
import screenFull from 'screenfull'

const ExpandableBarcodeListWithStore = () => {
  const store = useStore()
  return (
    <ExpandableBarcodeList
      totalQuantity={store.listStore?.totalQuantity ?? signal(0)}
      barcodes={store.listStore?.barcodes ?? signal([])}
      onClearList={() => {
        store.listStore?.removeAll()
      }}
      onExpandChange={async (isExpanded) => {
        if (isExpanded) {
          await store.sdk?.context?.frameSource?.switchToDesiredState(FrameSourceState.Standby)
          await store.sdk?.getCurrentMode()?.setEnabled(!isExpanded)
        } else {
          await store.sdk?.context?.frameSource?.switchToDesiredState(FrameSourceState.On)
          await store.sdk?.getCurrentMode()?.setEnabled(true)
        }
      }}
    />
  )
}

const MainPage = () => {
  const tracker = useTracker()
  const store = useStore()
  const open =
    store.initialOptionsStore.launched.value &&
    store.cameraStore.state.value === FrameSourceState.On &&
    !store.errorsStore.hasCameraAccessError.value // store.singleImageModeStore.enabled.value

  return (
    <>
      <Transition visible={open} duration={350} animation="fade down">
        <div>
          <Grid centered stackable className="container">
            <Grid.Row>
              <Grid.Column textAlign="center">
                {screenFull.isEnabled ? <FullscreenInfo /> : <div style={{ padding: '0.5rem' }}></div>}
                <MainMenu />
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </div>
      </Transition>
      <Show when={open}>
        <SignupLink>
          <MarkupText id="info.signUpTrial" />
        </SignupLink>
      </Show>
      <Show when={open}>
        <Tutorial
          onNextTip={() => tracker.sendEvent('Tutorial', 'advance')}
          onConfirmAction={() => tracker.sendEvent('Tutorial', 'skip')}
          onFinish={() => tracker.sendEvent('Tutorial', 'complete')}
        />
      </Show>
      <Show when={open}>
        <ExpandableBarcodeListWithStore />
      </Show>
    </>
  )
}
export default MainPage
